export const formatNumber = (locale: string, value: number) => {
  return new Intl.NumberFormat(`${locale}`).format(value);
};
